'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var defaultScrollOptions = { behavior: 'smooth', block: 'end', inline: 'nearest' };

var scrollToElement = function scrollToElement(domNode) {
  var scrollOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (domNode) {
    domNode.scrollIntoView(_extends({}, defaultScrollOptions, scrollOptions));
  }
};

exports.default = scrollToElement;